import apiService from './api.service';

export interface ErrorStats {
  totalErrors: number;
  errorTypes: number;
  timeline: Array<{
    time: string;
    errors: number;
  }>;
  topErrors: Array<{
    type: string;
    count: number;
  }>;
}

export interface ErrorGroup {
  errorType: string;
  errorMessage: string;
  operationName: string;
  occurrences: number;
  lastSeen: number;
  firstSeen: number;
  avgDuration: number;
}

export interface ErrorTrace {
  traceId: string;
  operationName: string;
  timestamp: number;
  durationMs: number;
  errorType: string;
  errorMessage: string;
  errorStack: string;
  context: {
    dbSystem?: string;
    dbStatement?: string;
    httpUrl?: string;
    httpMethod?: string;
    httpStatusCode?: string;
  };
}

class APMErrorsService {
  async getStats(
    applicationId: string,
    startTime: number,
    endTime: number
  ): Promise<{ success: boolean; data: ErrorStats }> {
    return apiService.get('/v1/apm/errors/stats', {
      params: { applicationId, startTime, endTime },
    });
  }

  async getErrors(
    applicationId: string,
    startTime: number,
    endTime: number,
    options?: {
      errorType?: string;
      limit?: number;
      offset?: number;
    }
  ): Promise<{
    success: boolean;
    data: ErrorGroup[];
    meta: { total: number; limit: number; offset: number };
  }> {
    return apiService.get('/v1/apm/errors', {
      params: {
        applicationId,
        startTime,
        endTime,
        ...options,
      },
    });
  }

  async getErrorTraces(
    applicationId: string,
    errorType: string,
    startTime: number,
    endTime: number,
    operationName?: string
  ): Promise<{ success: boolean; data: ErrorTrace[] }> {
    return apiService.get('/v1/apm/errors/traces', {
      params: {
        applicationId,
        errorType,
        startTime,
        endTime,
        operationName,
      },
    });
  }
}

export default new APMErrorsService();
